import { colorsPalette, styled } from '../theme';
import { Button } from './Button';

const FilterButton = styled(Button)(({ theme, color }) => ({
    ...theme.typography.body2,
    textAlign: 'left',
    '&.MuiButton-outlined': {
        padding: theme.spacing(0.5, 1),
    },
    '&.MuiButton-outlinedPrimary': {
        color: theme.palette.primary.main,
        background: colorsPalette.primaryAlpha[8],
        borderColor: theme.palette.primary.main,
        '&:focus, &:hover, &[disabled]': {
            color: theme.palette.primary.main,
            background: colorsPalette.primaryAlpha[20],
            borderColor: theme.palette.primary.main,
        },
    },
    ...(color === 'grayscale' && {
        color: theme.palette.text.primary,
        background: theme.palette.common.white,
        borderColor: theme.palette.divider,
        '&:focus, &:hover, &[disabled]': {
            color: theme.palette.text.primary,
            background: theme.palette.common.white,
            borderColor: colorsPalette.blackSolid[100],
        },
    }),
    '& .MuiButton-startIcon': {
        paddingLeft: theme.spacing(1),
    },
}));

export default FilterButton;
